
namespace TabAurous.Master {

    @Serenity.Decorators.registerClass()
    export class CamlyticsDialog extends Serenity.EntityDialog<CamlyticsRow, any> {
        protected getFormKey() { return CamlyticsForm.formKey; }
        protected getIdProperty() { return CamlyticsRow.idProperty; }
        protected getLocalTextPrefix() { return CamlyticsRow.localTextPrefix; }
        protected getNameProperty() { return CamlyticsRow.nameProperty; }
        protected getService() { return CamlyticsService.baseUrl; }
        protected getDeletePermission() { return CamlyticsRow.deletePermission; }
        protected getInsertPermission() { return CamlyticsRow.insertPermission; }
        protected getUpdatePermission() { return CamlyticsRow.updatePermission; }

        protected form = new CamlyticsForm(this.idPrefix);

    }
}